module.exports = __webpack_public_path__ + "img/blade_mail_axe_pw.9d717e80.png";